import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [salaControl, setSalaControl] = useState(() => localStorage.getItem("sentinel-theme") === "sala-control");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", salaControl);
    localStorage.setItem("sentinel-theme", salaControl ? "sala-control" : "office");
  }, [salaControl]);

  return (
    <ThemeContext.Provider value={{ salaControl, toggle: () => setSalaControl((v) => !v) }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useSentinelTheme() {
  return useContext(ThemeContext);
}
